import React, { useId } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className = '', id, ...props }: InputProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const errorId = error ? `${inputId}-error` : undefined;

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label htmlFor={inputId} className="text-[--clinqr-text-primary]">
          {label}
        </label>
      )}
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        className={`h-12 px-4 rounded-lg border-2 border-[--clinqr-border]
          bg-[--clinqr-bg-subtle] text-[--clinqr-text-primary]
          focus:outline-none focus:border-[--clinqr-primary] focus:ring-2 focus:ring-[--clinqr-primary]/20
          placeholder:text-[--clinqr-text-muted]
          transition-all duration-200
          disabled:opacity-50 disabled:cursor-not-allowed
          ${className}`}
        {...props}
      />
      {error && (
        <span id={errorId} className="text-[--clinqr-error]">{error}</span>
      )}
    </div>
  );
}
